import { MutationTree } from 'vuex'
import { State } from './state'
import { PageMutationTypes as MutationTypes } from './mutation-types'

export type Mutations<S = State> = {
  [MutationTypes.SET_THREE_MODE](state: S, payload: boolean): void;
  [MutationTypes.SET_RENDERING_MODE](state: S, payload: boolean): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_THREE_MODE](state: State, payload: boolean) {
    state.isThreeMode = payload
    log(MutationTypes.SET_THREE_MODE, payload)
  },
  [MutationTypes.SET_RENDERING_MODE](state: State, payload: boolean) {
    state.isRenderingMode = payload
    log(MutationTypes.SET_RENDERING_MODE, payload)
  }
}

const log = (mut: MutationTypes, msg: any) => {
  // console.log(mut + ' ' + msg)
}
